import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  Box,
  HeadingStyled,
  LazyImage,
  SpanStyled,
} from "../../styled/Elements";
import { HeaderContainer } from "../../admin/AdminHeader/styled";
import LangChangeButton from "../../../language/LangChangeButton";
import { MenuToggle } from "./styled";
import { Menu, UserPlaceholder } from "../../styled/AllImages";
import CustomDropdown from "../../common/dropdowns/CustomDropdown";
import LogoutModal from "../Modals/LogoutModal/LogoutModal";
import { useUser } from "../../../context/userContext";

const AdminHeader = ({ sidebarStatus, setSidebarStatus }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {user} = useUser();
  const hasLoginInLocation = location.pathname.includes("login");
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [isSticky, setIsSticky] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [profileImg, setProfileImg] = useState();

  const onLogout = () => {
    setShowLogout(true);
  };
  // useEffect(() => {
  //     if (user) {

  //         const baseAssetURL = process.env.REACT_APP_ASSET_URL;
  //         const profileUrl = user.profile ? `${baseAssetURL}/${user.profile}` : PlaceholderImg;
  //         setProfileImg(profileUrl);

  //     }
  // }, [user]);
  const profileDropdownList = [
    {
      label: "Profile",
      // icon: UserIcon,
      path: "profile",
    },
    {
      label: "Logout",
      // icon: LogoutIcon,
      // path: "login",
      onClick: onLogout,
    },
  ];

  const profileDropdownTitle = () => {
    return (
      <>
        <SpanStyled className="active-dot bg-transparent position-relative border-0 p-0">
          <LazyImage
            width="35px"
            height="35px"
            src={user?.profile ?`${process.env.REACT_APP_ASSET_URL}/${user?.profile}` : UserPlaceholder}
            className="rounded-circle"
          />
        </SpanStyled>
        {/* <SubHeadingStyled color="var(--text)" size="16px" className="mx-2">
          {t("abdullah")}
        </SubHeadingStyled> */}
      </>
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <HeaderContainer lang={language}>
        <Box className={`header-container px-3 px-md-4`}>
          <Box className="nav-bar justify-content-between">
            <Box className="d-flex align-items-center gap-2">
              <MenuToggle
                className="border-0 px-0 bg-transparent mb-1"
                onClick={() => setSidebarStatus(!sidebarStatus)}
              >
                <Menu />
              </MenuToggle>
              <HeadingStyled
                size="20px"
                weight="bold"
                color="var(--text)"
                className="greet-heading"
              >
                {t("hello")} {user?.name}!!!
              </HeadingStyled>
            </Box>
            <Box className="d-flex align-items-center">
              {/* <CustomDropdown
                                bg="var(--bgSecondary)"
                                color="var(--text)"
                                className="mx-2 support-dropdown"
                                itemsList={supportDropdownList}
                                title={t("contact_support")}
                            /> */}
              <LangChangeButton />
              <CustomDropdown
                bg="var(--white)"
                color="var(--text)"
                className="mx-2"
                paddingY={5}
                paddingX={5}
                itemsList={profileDropdownList}
                title={profileDropdownTitle()}
              />
            </Box>
          </Box>
        </Box>
        <LogoutModal show={showLogout} onHide={() => setShowLogout(false)} />
      </HeaderContainer>
    </>
  );
};

export default AdminHeader;
